import { IconMessageChatbot, IconUser } from "@tabler/icons-react";
import { Text } from "../../../../components/common/typography";
import { Chip } from "../../../../components/common/chip";
import type { AdminAiChatConversationMessage } from "../../../api_client";
import { formatDateTime, formatDuration, formatNumber, formatUSD } from "../utils/format";

interface ConversationMessageProps {
  message: AdminAiChatConversationMessage;
}

export function ConversationMessage({ message }: ConversationMessageProps) {
  const isAssistant = message.role === "assistant";

  return (
    <div className={`flex gap-3 rounded-lg px-4 py-3 ${isAssistant ? "bg-bgLight" : ""}`}>
      <div className="mt-0.5 shrink-0">
        {isAssistant ? (
          <IconMessageChatbot size={20} className="text-accentCyan" />
        ) : (
          <IconUser size={20} className="text-textMuted" />
        )}
      </div>
      <div className="min-w-0 flex-1">
        <div className="mb-1 flex items-center gap-2">
          <Text variant="bodySmBold" tone="dark">
            {isAssistant ? "Assistant" : "User"}
          </Text>
          <Text variant="bodyXs" tone="muted">{formatDateTime(message.createdAt)}</Text>
        </div>
        <Text variant="bodySm" tone="body" className="whitespace-pre-wrap break-words">
          {message.text}
        </Text>
        {isAssistant && message.costUSD != null && (
          <div className="mt-2 flex flex-wrap items-center gap-2">
            {message.model && <Chip variant="secondary">{message.model}</Chip>}
            <Text variant="bodyXs" tone="muted">
              {formatNumber(message.totalTokens ?? 0)} tokens
            </Text>
            <Text variant="bodyXs" tone="muted">
              {formatUSD(message.costUSD)}
            </Text>
            <Text variant="bodyXs" tone="muted">
              {formatDuration(message.durationMs)}
            </Text>
          </div>
        )}
      </div>
    </div>
  );
}
